import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L, SimpleListAdapter, TS_AppTools, TS_DropDown, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import './ATS_DropDown.scss';
import { generateArray, voidFunction } from '@nu-art/ts-common';
import { DropDown_DefaultCaret } from '../../consts.js';
export class ATS_DropDown extends ComponentSync {
    static Screen = {
        name: 'DropDown',
        key: 'drop-down',
        group: 'Components',
        renderer: this,
    };
    render() {
        const options = generateArray(15, op => `Option ${op + 1}`);
        const adapter = SimpleListAdapter(options, node => _jsx(_Fragment, { children: node.item }));
        return _jsxs(_Fragment, { children: [TS_AppTools.renderPageHeader('DropDown Test'), _jsx(LL_V_L, { className: 'ats-dropdown', children: _jsx(TS_PropRenderer.Vertical, { label: 'Regular', children: _jsx(TS_DropDown, { adapter: adapter, onSelected: voidFunction, placeholder: 'Placeholder', caret: DropDown_DefaultCaret }) }) })] });
    }
}
//# sourceMappingURL=ATS_DropDown.js.map